import { MASTER_DATA_API_ENDPOINT } from "app/helpers/config"
import { axiosInstance } from "../axiosInstance"

export const getMasterDataService = () => {
    return axiosInstance.get(MASTER_DATA_API_ENDPOINT)
}